<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="账号">
              <a-input placeholder="请输入账号模糊查询" v-model="queryParam.username"></a-input>
              <!-- <j-input placeholder="输入账号模糊查询" v-model="queryParam.username"></j-input> -->
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item label="真实名字">
              <a-input placeholder="请输入真实名字" v-model="queryParam.realname"></a-input>
            </a-form-item>
          </a-col>

          <template v-if="toggleSearchStatus">
            <a-col :md="6" :sm="8">
              <a-form-item label="性别">
                <a-select v-model="queryParam.sex" placeholder="请选择性别">
                  <a-select-option value="">请选择</a-select-option>
                  <a-select-option value="1">男性</a-select-option>
                  <a-select-option value="2">女性</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="8">
              <a-form-item label="手机号码">
                <a-input placeholder="请输入手机号码查询" v-model="queryParam.phone"></a-input>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="8">
              <a-form-item label="用户状态">
                <a-select v-model="queryParam.status" placeholder="请选择">
                  <a-select-option value="">请选择</a-select-option>
                  <a-select-option value="1">正常</a-select-option>
                  <a-select-option value="2">冻结</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item label="是否绑定CA锁">
                <a-select v-model="queryParam.caLock" placeholder="请选择">
                  <a-select-option value="">请选择</a-select-option>
                  <a-select-option value="1">是</a-select-option>
                  <a-select-option value="0">否</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>

          <a-col :md="6" :sm="8">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator" style="border-top: 5px">
      <a-button @click="handleAdd" type="primary" icon="plus">添加用户</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('用户信息')">导出</a-button>
      <a-upload
        name="file"
        :showUploadList="false"
        :multiple="false"
        :headers="tokenHeader"
        :action="importExcelUrl"
        @change="handleImportExcel"
      >
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-button type="primary" icon="hdd" @click="recycleBinVisible = true">回收站</a-button>
      <a-button type="primary" :loading="!!exportDecodeUserLoading" icon="download" @click="exportDecodeUser"
        >导出CA锁用户</a-button
      >
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay" @click="handleMenuClick">
          <a-menu-item key="1">
            <a-icon type="delete" @click="batchDel" />
            删除
          </a-menu-item>
          <a-menu-item key="2">
            <a-icon type="lock" @click="batchFrozen('2')" />
            冻结
          </a-menu-item>
          <a-menu-item key="3">
            <a-icon type="unlock" @click="batchFrozen('1')" />
            解冻
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;<a style="font-weight: 600">{{
          selectedRowKeys.length
        }}</a
        >项&nbsp;&nbsp;
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <template slot="caLock" slot-scope="text">
          {{ !text ? '否' : '是' }}
        </template>

        <template slot="avatarslot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <a-avatar shape="square" :src="getAvatarView(record.avatar)" icon="user" v-if="!dataSource[index].avatar">
            </a-avatar>
            <a-avatar
              :src="
                fileBaseUrl + '/download/fileView?attachGroup=' + record.avatar + '&attachPath=' + record.avatarPath
              "
              v-if="dataSource[index].avatar"
            />
          </div>
        </template>

        <span slot="action" slot-scope="text, record">
          <!-- <a @click="handleEdit(record)" v-has="'user:edit'">编辑</a>-->
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />

          <a-dropdown>
            <a class="ant-dropdown-link"> 更多 <a-icon type="down" /> </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a href="javascript:;" @click="handleDetail(record)">详情</a>
              </a-menu-item>

              <a-menu-item>
                <a href="javascript:;" @click="handleChangePassword(record.username)">密码</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handlePerssion(record)">授权</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item v-if="record.status == 1">
                <a-popconfirm title="确定冻结吗?" @confirm="() => handleFrozen(record.id, 2, record.username)">
                  <a>冻结</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item v-if="record.status == 2">
                <a-popconfirm title="确定解冻吗?" @confirm="() => handleFrozen(record.id, 1, record.username)">
                  <a>解冻</a>
                </a-popconfirm>
              </a-menu-item>
              <!-- <a-menu-item>
                <a href="javascript:;" @click="handleAgentSettings(record.username)">代理人</a>
              </a-menu-item> -->
            </a-menu>
          </a-dropdown>
          <!--  -->
          <a-divider type="vertical" />
          <a @click="handleExamine(record)">审批流 </a>
          <!--  -->
        </span>
      </a-table>
      <!-- -->

      <a-modal
        title="审批流设置"
        width="800px"
        :maskClosable="false"
        :visible="examineVisible"
        @ok="examineOk"
        @cancel="examineCancel"
      >
        <a-form :form="form">
          <a-form-model-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            ref="workFlowKey"
            prop="workFlowKey"
            label="审批流"
          >
            <a-select
              mode="multiple"
              placeholder="请选择审批流"
              v-model="workFlowKey"
              @search="handleSearch"
              :filter-option="filterOption"
              @change="handleChange"
              show-search
            >
              <a-select-option :key="index" :value="item.bizCode" v-for="(item, index) in workFlowList">{{
                item.desc
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form>
      </a-modal>
    </div>
    <!-- table区域-end -->

    <user-modal ref="modalForm" @ok="modalFormOk"></user-modal>

    <password-modal ref="passwordmodal" @ok="passwordModalOk"></password-modal>

    <sys-user-agent-modal ref="sysUserAgentModal"></sys-user-agent-modal>

    <!-- 用户回收站 -->
    <user-recycle-bin-modal :visible.sync="recycleBinVisible" @ok="modalFormOk" />

    <!--  用户授权弹窗    -->
    <user-role-modal ref="modalUserRole"></user-role-modal>
  </a-card>
</template>

<script>
import UserModal from './modules/UserModal'
import PasswordModal from './modules/PasswordModal'
import UserRoleModal from './modules/UserRoleModal'
import { putAction, downFile, getFileAccessHttpUrl, getAction } from '@/api/manage'
import { frozenBatch, addWorkFlow, frozenUser } from '@/api/api'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import SysUserAgentModal from './modules/SysUserAgentModal'
import JInput from '@/components/jeecg/JInput'
import UserRecycleBinModal from './modules/UserRecycleBinModal'
import axios from 'axios'
import { ACCESS_TOKEN, APPID } from '@/store/mutation-types'

let timeout
let currentValue
export default {
  name: 'UserList',
  mixins: [JeecgListMixin],
  components: {
    SysUserAgentModal,
    UserModal,
    PasswordModal,
    JInput,
    UserRecycleBinModal,
    UserRoleModal
  },
  data() {
    return {
      exportDecodeUserLoading: false,
      workFlowKey: [],
      workFlowList: [],
      examineVisible: false,
      workFlowUserId: '',
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      fileBaseUrl: window._CONFIG['fileUrl'],
      description: '这是用户管理页面',
      queryParam: {},
      recycleBinVisible: false,
      columns: [
        /*{
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },*/
        {
          title: '用户账号',
          align: 'center',
          dataIndex: 'username',
          width: 120,
          sorter: true
        },
        {
          title: '用户姓名',
          align: 'center',
          width: 100,
          dataIndex: 'realname'
        },
        {
          title: '头像',
          align: 'center',
          width: 120,
          dataIndex: 'avatar',
          scopedSlots: { customRender: 'avatarslot' }
        },

        {
          title: '性别',
          align: 'center',
          width: 80,
          dataIndex: 'sex_dictText',
          sorter: true
        },
        {
          title: '生日',
          align: 'center',
          width: 100,
          dataIndex: 'birthday'
        },
        {
          title: '手机号码',
          align: 'center',
          width: 100,
          dataIndex: 'phone'
        },
        {
          title: '部门',
          align: 'center',
          width: 180,
          dataIndex: 'orgCode'
        },
        {
          title: '负责部门',
          align: 'center',
          width: 180,
          dataIndex: 'departIds_dictText'
        },
        {
          title: '是否绑定CA锁',
          align: 'center',
          width: 180,
          dataIndex: 'caLock',
          scopedSlots: { customRender: 'caLock' }
        },
        {
          title: '状态',
          align: 'center',
          width: 80,
          dataIndex: 'status_dictText'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
          width: 170
        }
      ],
      url: {
        syncUser: '/process/extActProcess/doSyncUser',
        list: '/api/sys/user/list',
        delete: '/api/sys/user/delete',
        deleteBatch: '/api/sys/user/deleteBatch',
        exportXlsUrl: '/api/sys/user/exportXls',
        importExcelUrl: '/api/sys/user/importExcel'
      }
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    }
  },
  methods: {
    // 用户授权功能
    handlePerssion: function (record) {
      console.log('===========用户============', record)
      // alert(roleId);
      this.$refs.modalUserRole.show(record.id, 1, 1)
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    fetch(value, callback) {
      if (timeout) {
        clearTimeout(timeout)
        timeout = null
      }
      currentValue = value

      timeout = setTimeout(this.getWorkFlowList(), 300)
    },
    handleSearch(value) {
      this.fetch(value, (data) => (this.data = data))
    },
    handleChange(value) {
      console.log(value)
      this.value = value
      this.fetch(value, (data) => (this.data = data))
    },
    queryworkFlow() {
      getAction(`/api/sysuserworkflow/getByUserId/${this.workFlowUserId}`).then((res) => {
        if (res.result != null) {
          let arr = []
          res.result.map((el) => {
            arr.push(el.bizCode)
          })
          this.workFlowKey = arr
        }
      })
    },
    getWorkFlowList() {
      getAction('/api/sysuserworkflow/getBizList').then((res) => {
        if (res.success) {
          this.workFlowList = res.result
        }
      })
    },
    // 审批流设置
    handleExamine(record) {
      this.workFlowKey = []
      this.examineVisible = true
      console.log(record)
      this.workFlowUserId = record.id
      this.queryworkFlow()
      this.getWorkFlowList()
    },
    /* 导出四叶锁用户 */
    exportDecodeUser() {
      let params = this.getQueryParams()
      console.log(params)
      this.exportDecodeUserLoading = true
      const serve = axios.create({ timeout: 12000 })
      let url = `/base-platform/api/sys/user/exportCaXls`
      console.log(url)
      serve({
        method: 'get',
        url,
        responseType: 'blob',
        headers: {
          'X-Access-Token': this.$ls.get(ACCESS_TOKEN),
          appId: this.$ls.get(APPID),
          'content-type': 'application/json;charset=gbk',
          content: 'application/html; charset=gbk'
        },
        params
      })
        .then((res) => {
          if (!window.navigator.msSaveBlob) {
            try {
              let url = window.URL.createObjectURL(new Blob([res.data]))
              let link = document.createElement('a')
              link.style.display = 'none'
              link.href = url
              link.setAttribute('download', '导出CA锁用户.xls')
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link) //下载完成移除元素
              window.URL.revokeObjectURL(url) //释放掉blob对象
            } catch (err) {
              this.$message.error('导入失败')
            }
          } else {
            window.navigator.msSaveBlob(new Blob([res.data]), '导出CA锁用户.xls')
          }
        })
        .finally(() => {
          this.exportDecodeUserLoading = false
        })
    },
    examineOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          let params = {
            id: 0,
            userId: this.workFlowUserId
          }
          let data = { bizCode: this.workFlowKey.join(',') }
          let formData = Object.assign(params, data)
          console.log(formData)
          // if(data.bizCode==""){
          //   this.$message.warning("审核流不能未空!")
          // }else{
          addWorkFlow(formData).then((res) => {
            if (res.success) {
              this.$message.success(res.message)
              this.examineVisible = false
            } else {
              this.$message.error(res.message)
            }
          })
          // }
        }
      })
    },
    examineCancel() {
      this.examineVisible = false
    },
    getAvatarView: function (avatar) {
      return getFileAccessHttpUrl(avatar)
    },

    batchFrozen: function (status) {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！')
        return false
      } else {
        let ids = ''
        let that = this
        let isAdmin = false
        that.selectionRows.forEach(function (row) {
          if (row.username == 'admin') {
            isAdmin = true
          }
        })
        if (isAdmin) {
          that.$message.warning('管理员账号不允许此操作,请重新选择！')
          return
        }
        that.selectedRowKeys.forEach(function (val) {
          ids += val + ','
        })
        that.$confirm({
          title: '确认操作',
          content: '是否' + (status == 1 ? '解冻' : '冻结') + '选中账号?',
          onOk: function () {
            frozenBatch({ ids: ids, status: status }).then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.loadData()
                that.onClearSelected()
              } else {
                that.$message.warning(res.message)
              }
            })
          }
        })
      }
    },
    handleMenuClick(e) {
      if (e.key == 1) {
        this.batchDel()
      } else if (e.key == 2) {
        this.batchFrozen(2)
      } else if (e.key == 3) {
        this.batchFrozen(1)
      }
    },
    handleFrozen: function (id, status, username) {
      let that = this
      //TODO 后台校验管理员角色
      if ('admin' == username) {
        that.$message.warning('管理员账号不允许此操作！')
        return
      }
      frozenBatch({ ids: id, status: status }).then((res) => {
        if (res.success) {
          that.$message.success(res.message)
          that.loadData()
        } else {
          that.$message.warning(res.message)
        }
      })
    },
    handleChangePassword(username) {
      this.$refs.passwordmodal.show(username)
    },
    handleAgentSettings(username) {
      this.$refs.sysUserAgentModal.agentSettings(username)
      this.$refs.sysUserAgentModal.title = '用户代理人设置'
    },
    passwordModalOk() {
      //TODO 密码修改完成 不需要刷新页面，可以把datasource中的数据更新一下
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
